import { Box, chakra, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const Container = ({ children, className }: Props) => {
  const bgColor = useColorModeValue('#FBFCFE', '#171717');

  return (
    <Box
      className={ className }
      w="100%"
      minW={ 0 }
      m={ 0 }
      bgColor={ bgColor }
      overflowX="clip"
    >
      { children }
    </Box>
  );
};

export default React.memo(chakra(Container));
